<script setup lang="ts">
export interface DropdownEmits {
    // eslint-disable-next-line no-unused-vars
    (e: 'close', value: any): void
}

export interface DropdownProps {
    classes?: string
    // Unique id for accessibility (aria-controls/aria-labelledby)
    dropdownId?: string
}

const emit = defineEmits<DropdownEmits>()

const props = withDefaults(defineProps<DropdownProps>(), {
    classes: 'normal',
    dropdownId: undefined,
})

// Generate unique id for this dropdown instance
const uniqueId = props.dropdownId || `dropdown-${Math.random().toString(36).substring(2, 9)}`
const menuId = `${uniqueId}-menu`

// Provide ids to parent for button aria-controls
defineExpose({
    menuId,
})

const handleClickOutside = (e: Event): void => {
    emit('close', e)
}

const handleClickOnDropdownContent = (e: Event): void => {
    e.stopPropagation()
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
})
</script>
<template>
  <div class="dropdown position-relative">
    <slot name="button" />
    <div
      :id="menuId"
      role="menu"
      class="dropdown-menu bg-white rounded z-index-5 py-6 ps-6 pe-4 h-auto"
      :class="props.classes"
      @click="handleClickOnDropdownContent"
    >
      <div
        class="dropdown-content pe-2"
      >
        <slot name="content" />
      </div>
    </div>
  </div>
</template>
<style>
@import './Dropdown.vars.scss';
</style>
<style lang="scss">
@import './Dropdown.scss';
</style>
